import React from "react";
import Reveal from "./Reveal";

const OFFERINGS = [
  {
    n: "01",
    title: "AI Jobs — The Talent Marketplace",
    body: (
      <>
        <p className="mb-3">
          <span className="font-medium" style={{ color: "var(--ink)" }}>For job seekers:</span>{" "}
          AI-powered resume building, smart matching to AI roles, interview prep, skill
          analysis, and direct visibility to employers actively hiring AI talent. Every
          certified practitioner enters the marketplace by default.
        </p>
        <p className="mb-3">
          <span className="font-medium" style={{ color: "var(--ink)" }}>For employers and talent acquisition teams:</span>{" "}
          post AI roles, search a verified pool of certified AI practitioners, build branded
          talent pools, and recruit directly from Innovation Arena cohorts before candidates
          enter the open market.
        </p>
        <p className="italic" style={{ color: "var(--ink)" }}>
          One platform. Two sides. Pre-vetted AI talent on demand.
        </p>
      </>
    ),
  },
  {
    n: "02",
    title: "Pitch Hub",
    body: "For founders building AI products. Upload a 3-minute pitch. Get discovered by investors. Close rounds faster. For investors: discover AI deals from a curated pool of practitioner-founders.",
  },
  {
    n: "03",
    title: "Community",
    body: "Discussion forums, office hours with mentors, monthly events. Connect with practitioners building across industries and geographies.",
  },
  {
    n: "04",
    title: "Partner Ecosystem",
    body: "Authorized Partners deliver AI For Everyone certifications in their region. Certified Trainers facilitate. This is how the ecosystem scales — globally.",
  },
];

export default function BeyondCourses() {
  return (
    <section
      id="beyond"
      className="py-10 md:py-14 border-t hairline"
      style={{ background: "var(--canvas-deep)" }}
      data-testid="beyond-section"
    >
      <div className="container-edge">
        <Reveal>
          <p className="section-number">05 — BEYOND COURSES</p>
        </Reveal>
        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <Reveal>
              <h2
                className="font-display text-[40px] sm:text-[52px] lg:text-[68px] leading-[0.95] tracking-tight"
                style={{ fontWeight: 500 }}
              >
                What happens after <em className="italic grad-brand-text" style={{ fontWeight: 500 }}>you learn.</em>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <Reveal delay={120}>
              <p className="text-[17px] md:text-[19px] leading-relaxed" style={{ color: "var(--ink-secondary)" }}>
                A certificate is the beginning, not the end. Here is what AI For Everyone offers
                every practitioner who joins the ecosystem.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-10 divide-y" style={{ borderColor: "var(--border-soft)" }}>
          {OFFERINGS.map((o, i) => (
            <Reveal key={o.n} delay={i * 60}>
              <div
                className="grid grid-cols-12 gap-6 py-7 border-t hairline"
                data-testid={`beyond-row-${o.n}`}
              >
                <div className="col-span-2 md:col-span-1">
                  <p className="font-mono text-[14px]" style={{ color: "var(--accent-gold)", letterSpacing: "0.12em" }}>
                    {o.n}
                  </p>
                </div>
                <div className="col-span-10 md:col-span-4">
                  <h3
                    className="font-display text-[26px] md:text-[30px] tracking-tight"
                    style={{ fontWeight: 500 }}
                  >
                    {o.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-7">
                  <div className="text-[15px] leading-relaxed" style={{ color: "var(--ink-secondary)" }}>
                    {o.body}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
